/**
 * Display-only mapping for audit_log.action → Thai label.
 *
 * DB still stores the English code (stable for indexing + programmatic
 * filtering); this file is *only* for rendering in the Audit page +
 * dashboard ticker.
 */

const ACTION_LABELS: Record<string, string> = {
  // === Identity / Auth ===
  USER_PAIRED: 'ผูก LINE กับพนักงาน',
  EMPLOYEE_ONBOARDED: 'รับพนักงานใหม่',
  EMPLOYEE_UPSERT: 'แก้ไขข้อมูลพนักงาน',
  STAFF_INVITED: 'เชิญพนักงาน',
  PROFILE_SELF_UPDATED: 'พนักงานแก้ประวัติตนเอง',

  // === Leave (direct + via LINE) ===
  LEAVE_SUBMITTED: 'ส่งใบลา',
  LEAVE_APPROVE: 'อนุมัติใบลา',
  LEAVE_REJECT: 'ปฏิเสธใบลา',
  LEAVE_REQUEST_INFO: 'ขอข้อมูลใบลาเพิ่ม',
  LEAVE_CONDITIONAL_APPROVE: 'อนุมัติแบบมีเงื่อนไข',
  LEAVE_APPROVED_VIA_LINE: 'อนุมัติใบลาผ่าน LINE',
  LEAVE_REJECTED_VIA_LINE: 'ปฏิเสธใบลาผ่าน LINE',
  LEAVE_INFO_RESPONDED: 'พนักงานตอบขอข้อมูลเพิ่ม',
  LEAVE_CONDITIONAL_EVIDENCE_SUBMITTED: 'ส่งหลักฐานเงื่อนไข',

  // === OT ===
  OT_SUBMITTED: 'ส่งใบขอ OT',
  OT_APPROVE: 'อนุมัติ OT',
  OT_REJECT: 'ปฏิเสธ OT',
  OT_REQUEST_INFO: 'ขอข้อมูล OT เพิ่ม',
  OT_APPROVED_VIA_LINE: 'อนุมัติ OT ผ่าน LINE',
  OT_REJECTED_VIA_LINE: 'ปฏิเสธ OT ผ่าน LINE',

  // === Check-in (4 events / day) ===
  CHECKIN_MORNING_IN: 'เช็คอินเช้า',
  CHECKIN_LUNCH_OUT: 'พักเที่ยง (ออก)',
  CHECKIN_LUNCH_IN: 'พักเที่ยง (กลับ)',
  CHECKIN_EVENING_OUT: 'เลิกงาน',
  UNSCHEDULED_WORK_FLAGGED: 'มาทำงานวันที่ไม่ได้กำหนด',

  DECISION_ACKNOWLEDGED: 'รับทราบผลคำขอ',

  // === Approval chain ===
  ESCALATION_ACK: 'รับทราบ Escalation',
  ESCALATION_DISMISS: 'ปิด Escalation',
  ESCALATION_TRANSFERRED: 'โอน Escalation',
  ESCALATION_RESOLVE: 'แก้ไข Escalation',

  // === HR CRUD ===
  ALLOWANCE_CREATED: 'เพิ่มเงินช่วยเหลือ',
  ALLOWANCE_DELETED: 'ลบเงินช่วยเหลือ',
  HOLIDAY_UPSERT: 'แก้ไขวันหยุด',
  HOLIDAY_DELETED: 'ลบวันหยุด',
  QUOTA_UPSERT: 'แก้ไขสิทธิ์การลา',

  // === Pending changes (HR → Owner approval) ===
  PENDING_CHANGE_APPROVE: 'Owner อนุมัติคำขอเปลี่ยนของ HR',
  PENDING_CHANGE_REJECT: 'Owner ปฏิเสธคำขอเปลี่ยนของ HR',

  // === Payroll (Owner only) ===
  RECONCILE_RUN: 'Reconcile งวด',
  PAYROLL_RUN: 'คำนวณเงินเดือน (Run Draft)',
  PAYROLL_PREVIEWED: 'Preview เงินเดือน',
  PAYROLL_APPROVED: 'อนุมัติเงินเดือน',
  PAYROLL_REJECTED: 'ปฏิเสธ Payroll งวด',
  YTD_RECOMPUTED: 'คำนวณ YTD ใหม่',
  EMPLOYEE_TERMINATED: 'พนักงานออกจากงาน',
  PND1K_EXPORTED: 'ดาวน์โหลด ภงด.1ก',
  SHIFT_CREATED: 'สร้างกะ',
  SHIFT_UPDATED: 'แก้ไขกะ',
  SHIFT_DEACTIVATED: 'ปิดกะ',
  SHIFT_ASSIGN_CREATED: 'ผูกกะกับพนักงาน',
  SHIFT_ASSIGN_UPDATED: 'แก้ไขการผูกกะ',
  SHIFT_ASSIGN_DELETED: 'ลบการผูกกะ',
  SHIFT_SWAP_REQUESTED: 'ขอแลกเวร',
  SHIFT_SWAP_APPROVED: 'อนุมัติแลกเวร',
  SHIFT_SWAP_REJECTED: 'ปฏิเสธแลกเวร',
  EXPORT_EMPLOYEES: 'Export พนักงาน',
  EXPORT_LEAVES: 'Export ใบลา/OT',
  EXPORT_PAYROLL: 'Export payroll',
  TENANT_DELETED: 'ลบบริษัท',
  COMMISSION_PKG_CREATED: 'สร้าง Commission Package',
  COMMISSION_PKG_UPDATED: 'แก้ไข Commission Package',
  COMMISSION_PKG_DEACTIVATED: 'ปิด Commission Package',
  COMMISSION_ELIG_CREATED: 'เพิ่ม Commission eligibility',
  COMMISSION_ELIG_UPDATED: 'แก้ไข Commission eligibility',
  COMMISSION_ELIG_DELETED: 'ลบ Commission eligibility',
  COMMISSION_RUN_CREATED: 'สร้าง Commission Run',
  COMMISSION_CALCULATED: 'คำนวณ Commission',
  COMMISSION_REVIEWED: 'Review Commission',
  COMMISSION_LOCKED: 'Lock Commission + feed payroll',
  DATA_ENTRY_ALLOWANCE_UPSERT: 'แก้ไข qty variable allowance',
  DATA_ENTRY_ADJUSTMENT_UPSERT: 'แก้ไข one-off adjustment',
  DATA_ENTRY_DELETED: 'ลบ data entry',
  ALLOWANCE_MASTER_CREATED: 'สร้าง Allowance Master',
  ALLOWANCE_MASTER_UPDATED: 'แก้ไข Allowance Master',
  ALLOWANCE_MASTER_DEACTIVATED: 'ปิด Allowance Master',
  ALLOWANCE_ELIG_CREATED: 'ผูก Allowance กับพนักงาน',
  ALLOWANCE_ELIG_UPDATED: 'แก้ไข Allowance eligibility',
  ALLOWANCE_ELIG_DELETED: 'ลบ Allowance eligibility',
  PERIOD_LOCKED: 'ล็อกงวดเงินเดือน',
  PERIOD_LOCK_BLOCKED: 'ปิดงวดถูกบล็อก (ยังมีเรื่องต้องแก้)',
  PII_REVEAL: 'เปิดดูเลขบัตร/รูปบัตรประชาชน',
  PAY_BAND_REVEAL: 'เปิดดูช่วงเงินเดือน',
  SALARY_ANALYSIS_VIEWED: 'เปิดดูวิเคราะห์เงินเดือนทั้งองค์กร',
  SLIPS_SENT: 'ส่งสลิปเงินเดือน',
  DEDUCTION_CREATED: 'เพิ่มรายการหักประจำ',

  // === Documents / Education / Work history ===
  DOCUMENT_UPLOADED: 'อัปโหลดเอกสาร',
  DOCUMENT_DELETED: 'ลบเอกสาร',
  EDUCATION_CREATED: 'เพิ่มประวัติการศึกษา',
  EDUCATION_UPDATED: 'แก้ไขประวัติการศึกษา',
  EDUCATION_DELETED: 'ลบประวัติการศึกษา',
  WORK_HISTORY_CREATED: 'เพิ่มประวัติการทำงาน',
  WORK_HISTORY_UPDATED: 'แก้ไขประวัติการทำงาน',
  WORK_HISTORY_DELETED: 'ลบประวัติการทำงาน',

  // === Profile follow-up pipeline ===
  PROFILE_FOLLOWUP_DAY7_SENT: 'ส่งเตือนกรอกประวัติ Day 7',
  PROFILE_FOLLOWUP_DAY14_SENT: 'ส่ง Escalation Day 14 ให้ admin',
  PROFILE_FOLLOWUP_TODO_CREATED: 'สร้าง To-Do ตามเก็บประวัติ',
  PROFILE_FOLLOWUP_PAUSED: 'หยุดติดตามชั่วคราว',
  PROFILE_FOLLOWUP_RESUMED: 'กลับมาติดตาม',
  PROFILE_FOLLOWUP_SNOOZED: 'เลื่อนติดตาม',
  PROFILE_FOLLOWUP_TEST_ADVANCE: '[Test] ย้อนเวลา followup',
  PROFILE_FOLLOWUP_TEST_RUN_NOW: '[Test] รัน cron ทันที',

  // === System / Integrations ===
  SETTINGS_UPDATED: 'แก้ไขตั้งค่าระบบ',
  PROBATION_DECIDED: 'ตัดสินทดลองงาน',
  PROBATION_STATUS_SYNCED: 'เปลี่ยนเป็นพนักงานประจำ (ตัดสินทดลองงานแล้ว)',
  PROBATION_REOPENED: 'เปิดทดลองงานใหม่',
  CACHE_INVALIDATED: 'ล้าง cache',
  SHEET_SYNC: 'ซิงค์ Google Sheet',
  SHEET_SYNC_TRIGGERED: 'สั่งซิงค์ Google Sheet',
  DRIVE_SYNC: 'ซิงค์ Google Drive',
  DRIVE_SYNC_TRIGGERED: 'สั่งซิงค์ Google Drive',
  DRIVE_CONFIGURED: 'ตั้งค่า Google Drive',
  DRIVE_AUDIT: 'ตรวจสอบ Drive',
};

/**
 * Translate an audit action code to a Thai label. Unknown codes are
 * returned verbatim so the UI never crashes on a new action that hasn't
 * been mapped yet — operator can still read the raw English.
 */
export function auditActionLabel(action: string | null | undefined): string {
  if (!action) return '—';
  return ACTION_LABELS[action] ?? action;
}

const TARGET_TYPE_LABELS: Record<string, string> = {
  user: 'ผู้ใช้',
  employee: 'พนักงาน',
  leave: 'ใบลา',
  ot: 'OT',
  attendance_event: 'เช็คอิน',
  document: 'เอกสาร',
  education: 'การศึกษา',
  work_history: 'การทำงาน',
  drive: 'Google Drive',
  sheet: 'Google Sheet',
  profile: 'ประวัติ',
};

export function targetTypeLabel(targetType: string | null | undefined): string {
  if (!targetType) return '';
  return TARGET_TYPE_LABELS[targetType] ?? targetType;
}

/**
 * Group actions for the filter dropdown. Each group becomes an
 * <optgroup> in the UI.
 */
export const ACTION_FILTER_GROUPS: Array<{ label: string; actions: string[] }> = [
  { label: 'พนักงาน', actions: ['USER_PAIRED', 'EMPLOYEE_ONBOARDED', 'EMPLOYEE_UPSERT', 'STAFF_INVITED', 'PROFILE_SELF_UPDATED', 'PROBATION_DECIDED', 'PROBATION_STATUS_SYNCED', 'PROBATION_REOPENED'] },
  { label: 'ใบลา', actions: ['LEAVE_SUBMITTED', 'LEAVE_APPROVE', 'LEAVE_REJECT', 'LEAVE_REQUEST_INFO', 'LEAVE_CONDITIONAL_APPROVE', 'LEAVE_INFO_RESPONDED'] },
  { label: 'OT', actions: ['OT_SUBMITTED', 'OT_APPROVE', 'OT_REJECT', 'OT_REQUEST_INFO'] },
  { label: 'เช็คอิน', actions: ['CHECKIN_MORNING_IN', 'CHECKIN_LUNCH_OUT', 'CHECKIN_LUNCH_IN', 'CHECKIN_EVENING_OUT', 'UNSCHEDULED_WORK_FLAGGED'] },
  { label: 'เงินเดือน', actions: ['RECONCILE_RUN', 'PAYROLL_RUN', 'PERIOD_LOCKED', 'PERIOD_LOCK_BLOCKED', 'SLIPS_SENT', 'DEDUCTION_CREATED'] },
  { label: 'ประวัติ', actions: ['DOCUMENT_UPLOADED', 'DOCUMENT_DELETED', 'EDUCATION_CREATED', 'WORK_HISTORY_CREATED'] },
  { label: 'ติดตามประวัติ', actions: ['PROFILE_FOLLOWUP_DAY7_SENT', 'PROFILE_FOLLOWUP_DAY14_SENT', 'PROFILE_FOLLOWUP_TODO_CREATED', 'PROFILE_FOLLOWUP_PAUSED', 'PROFILE_FOLLOWUP_RESUMED', 'PROFILE_FOLLOWUP_SNOOZED'] },
  { label: 'เปิดดูข้อมูลอ่อนไหว', actions: ['PII_REVEAL', 'PAY_BAND_REVEAL', 'SALARY_ANALYSIS_VIEWED'] },
  { label: 'ระบบ', actions: ['SETTINGS_UPDATED', 'SHEET_SYNC', 'DRIVE_SYNC', 'DRIVE_CONFIGURED'] },
];
